import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import { ResponsivePageContainer } from '../../components/PageContainers'
import { InspectionStatusChip, InspectionChipStatus } from './InspectionStatusChip'

interface InspectionDetailShellProps {
    title: string
    subtitle?: string
    status?: InspectionChipStatus
    metadata?: string[]
    onBack: () => void
    children: React.ReactNode
}

export const InspectionDetailShell: React.FC<InspectionDetailShellProps> = ({
    title,
    subtitle,
    status,
    metadata = [],
    onBack,
    children,
}) => {
    return (
        <ResponsivePageContainer title={title}>
            <Box sx={{ maxWidth: '800px', width: '100%' }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={onBack}
                    sx={{
                        mb: 2,
                        textTransform: 'none',
                        color: 'rgba(255,255,255,0.7)',
                    }}
                >
                    Back to Inspections
                </Button>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        gap: 1,
                        mb: 1,
                        flexWrap: 'wrap',
                    }}
                >
                    <Box>
                        {subtitle && (
                            <Typography
                                variant="body2"
                                sx={{ color: 'rgba(255,255,255,0.5)', mb: 0.5 }}
                            >
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                    {status && <InspectionStatusChip status={status} />}
                </Box>

                {metadata.length > 0 && (
                    <Typography
                        variant="body2"
                        sx={{ color: 'rgba(255,255,255,0.5)', mb: 3 }}
                    >
                        {metadata.join('  ·  ')}
                    </Typography>
                )}

                {children}
            </Box>
        </ResponsivePageContainer>
    )
}
